export const mockData = [
  {
    key: "total-sales",
    type: "Total Sales",
    children: [
      {
        key: "amazon-sales",
        type: "Amazon Sales",
        children: [
          {
            key: "ad",
            type: "Ad",
            months: {
              "1 Jan": "($XXX)",
              "2 Jan": "($XXX)",
              "3 Jan": "($XXX)",
              "4 Jan": "($XXX)",
              "5 Jan": "($XXX)",
              "6 Jan": "($XXX)",
            },
          },
          {
            key: "organic",
            type: "Organic",
            months: {
              "1 Jan": "($XXX)",
              "2 Jan": "($XXX)",
              "3 Jan": "($XXX)",
              "4 Jan": "($XXX)",
              "5 Jan": "($XXX)",
              "6 Jan": "($XXX)",
            },
          },
        ],
        months: {
          "1 Jan": "($XXX)",
          "2 Jan": "($XXX)",
          "3 Jan": "($XXX)",
          "4 Jan": "($XXX)",
          "5 Jan": "($XXX)",
          "6 Jan": "($XXX)",
        },
      },
      {
        key: "other-sales",
        type: "Other Sales",
        months: {
          "1 Jan": "($XXX)",
          "2 Jan": "($XXX)",
          "3 Jan": "($XXX)",
          "4 Jan": "($XXX)",
          "5 Jan": "($XXX)",
          "6 Jan": "($XXX)",
        },
      },
    ],
    months: {
      "1 Jan": "($XXX)",
      "2 Jan": "($XXX)",
      "3 Jan": "($XXX)",
      "4 Jan": "($XXX)",
      "5 Jan": "($XXX)",
      "6 Jan": "($XXX)",
    },
  },
  {
    key: "cost-of-goods-sold",
    type: "Cost of Goods Sold",
    months: {
      "1 Jan": "($XXX)",
      "2 Jan": "($XXX)",
      "3 Jan": "($XXX)",
      "4 Jan": "($XXX)",
      "5 Jan": "($XXX)",
      "6 Jan": "($XXX)",
    },
    isRed: true,
  },
  {
    key: "overhead-cost",
    type: "Overhead Cost",
    months: {
      "1 Jan": "($XXX)",
      "2 Jan": "($XXX)",
      "3 Jan": "($XXX)",
      "4 Jan": "($XXX)",
      "5 Jan": "($XXX)",
      "6 Jan": "($XXX)",
    },
    isRed: true,
  },
  {
    key: "contribution-profit",
    type: "Contribution Profit",
    months: {
      "1 Jan": "($XXX)",
      "2 Jan": "($XXX)",
      "3 Jan": "($XXX)",
      "4 Jan": "($XXX)",
      "5 Jan": "($XXX)",
      "6 Jan": "($XXX)",
    },
  },
  {
    key: "contribution-margin",
    type: "Contribution Margin",
    months: {
      "1 Jan": "($XXX)",
      "2 Jan": "($XXX)",
      "3 Jan": "($XXX)",
      "4 Jan": "($XXX)",
      "5 Jan": "($XXX)",
      "6 Jan": "($XXX)",
    },
  },
  {
    key: "opex",
    type: "OPEX",
    months: {
      "1 Jan": "($XXX)",
      "2 Jan": "($XXX)",
      "3 Jan": "($XXX)",
      "4 Jan": "($XXX)",
      "5 Jan": "($XXX)",
      "6 Jan": "($XXX)",
    },
    isRed: true,
  },
  {
    key: "cash-flow",
    type: "Cash Flow",
    months: {
      "1 Jan": "($XXX)",
      "2 Jan": "($XXX)",
      "3 Jan": "($XXX)",
      "4 Jan": "($XXX)",
      "5 Jan": "($XXX)",
      "6 Jan": "($XXX)",
    },
  },
];
